import Language from '@assetsJsModule/common/Language';

import ContactFormClient from './ContactFormClient';
import { axiosInstance, axiosInterceptor } from '../../paysera-recaptcha-modal';

export default () => {
    const instance = axiosInstance();
    const language = new Language();
    instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    instance.defaults.maxRedirects = 0;
    instance.interceptors.response.use(
        response => response,
        async error => ((await axiosInterceptor)(error)),
    );

    return new ContactFormClient(instance, language);
};
